"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClientAddressPageProp = exports.CLIENT_ADDRESS_PROP = void 0;
const libs_next_utils_1 = require("@hotelplan/libs.next-utils");
exports.CLIENT_ADDRESS_PROP = '_cap';
exports.getClientAddressPageProp = (0, libs_next_utils_1.createPagePropGetter)(exports.CLIENT_ADDRESS_PROP, {
    clientAddress: '',
});
//# sourceMappingURL=client-address.utils.js.map